import { render, staticRenderFns } from "./widget-context.vue?vue&type=template&id=d2b02838&"
import script from "./widget-context.vue?vue&type=script&lang=ts&"
export * from "./widget-context.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports